import {InteractiveProductTileBase} from '@aboutyou/ui-components';
import React from 'react';
import {InteractiveTileImagePreload} from './InteractiveTileImagePreload';
import {ProductTile, ProductTileProps} from './ProductTile';
import {useOnColorHover} from './hooks/useOnColorHover';

export const InteractiveProductTile: React.FC<
  Omit<ProductTileProps, 'ProductTileComponent'>
> = props => {
  const {
    onHover: onColorHover,
    tile: hoveredTile,
    resetTile,
    loaded,
    onImageLoad,
  } = useOnColorHover(props.tile, props.category);

  const tile = loaded && hoveredTile ? hoveredTile : props.tile;

  return (
    <>
      <HoverGalleryProductTile
        {...props}
        tile={tile}
        onColorHover={onColorHover}
        onColorLeave={resetTile}
      />
      {hoveredTile && !loaded && (
        <InteractiveTileImagePreload
          data-testid="InteractiveProductTile-preload-image"
          onImageLoad={onImageLoad}
          tile={hoveredTile}
        />
      )}
    </>
  );
};

/**
 * This tile can be used if we want to have a
 * product tile, which is interactive, but variant switching will
 * not be possible (e.g Coupon landing page)
 * @param props
 * @constructor
 */
const HoverGalleryProductTile = (
  props: Omit<ProductTileProps, 'ProductTileComponent'>,
) => {
  return (
    <>
      <ProductTile
        {...props}
        ProductTileComponent={InteractiveProductTileBase}
      />
    </>
  );
};
